module.exports = __webpack_public_path__ + "static/media/main_slider_3.6e20c05c.jpg";